import DetailPerfil from "./DetailPerfil";
export default DetailPerfil;
